import React, { useState } from "react";

import { useAppContext } from "../../Context/AppContext.jsx";
import { RiAdminLine } from "react-icons/ri";
import { FaRegUserCircle } from "react-icons/fa";
import { HiOutlineChevronDown } from "react-icons/hi2";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { VscChevronUp } from "react-icons/vsc";

const DashboardHeader = () => {
  const { user, logout } = useAppContext();
  const [userOptionsOpen, setUserOptionsOpen] = useState(false);
  const navigate = useNavigate();
  const handleLogout = async () => {
    const promise = () =>
      new Promise((resolve, reject) => {
        setTimeout(() => {
          logout();
          navigate("/login");
          resolve({
            name: "Sesión terminada con exito.",
          });
        }, 1000);
      });

    await toast.promise(promise, {
      loading: "Cerrando sesión...",
      success: (data) => {
        return data.name;
      },
      error: "Error al cerrar sesión.",
    });

    return;
  };
  return (
    <div className="w-full px-4 bg-[#FAFBFD] py-4 flex items-center ">
      <div className="flex items-center w-screen">
        <h1 className="text-xl md:text-3xl xl:text-4xl font-bold text-transparent uppercase font-Roboto bg-clip-text bg-gradient-to-r from-pink-400 to-mariposa">
          Dashboard
        </h1>

        <div className="ml-auto flex  flex items-center">
          <div className="text-xl hidden md:block md:text-2xl  text-slate-600 font-medium font-Roboto first-letter:text-mariposa">
            {user.username}
          </div>
          <div
            className="relative rounded-3xl bg-mariposa p-3 flex flex ml-2 cursor-pointer"
            onClick={() => {
              setUserOptionsOpen(!userOptionsOpen);
            }}
          >
            {user.rol === "admin" ? (
              <RiAdminLine className="text-white text-3xl bg-mariposa p-1" />
            ) : (
              <FaRegUserCircle />
            )}

            <span className="text-white text-xl capitalize ml-2">
              {user.rol}
            </span>

            {userOptionsOpen ? (
              <VscChevronUp className="text-white text-3xl bg-mariposa p-1" />
            ) : (
              <HiOutlineChevronDown className="text-white text-3xl bg-mariposa p-1" />
            )}

            {userOptionsOpen ? (
              <div className="transition-all">
                <div className="absolute w-0 h-0 right-[10%] top-[100%] border-white border-b-[11px] border-l-[10px] border-r-[10px] border-b-gray-200 bg-white z-50 transition-all"></div>
                <div className="absolute -left-[10px] top-[120%] z-50 bg-white rounded-md shadow-lg   py-2 px-4 flex flex-col gap-y-2">
                  <div className="text-md  md:text-lg  text-slate-600 font-medium font-Roboto first-letter:text-mariposa">
                    {user.username}
                    <button
                      className="text-slate-600 mt-2 font-semibold cursor-pointer"
                      onClick={() => handleLogout()}
                    >
                      {" "}
                      Cerrar Sesión
                    </button>
                  </div>

                  <div></div>
                </div>
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardHeader;
